import {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'

const App = () => {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'PROD') {
      const scripts: HTMLScriptElement[] = []

      // Add infoset.js script (only if not already loaded)
      if (!document.querySelector('script[src="/infoset.js"]')) {
        const infosetScript = document.createElement('script')
        infosetScript.src = '/infoset.js'
        infosetScript.async = true
        document.body.appendChild(infosetScript)
        scripts.push(infosetScript)
      }

      // Add HubSpot script (only if not already loaded)
      if (!document.getElementById('hs-script-loader')) {
        const hubspotScript = document.createElement('script')
        hubspotScript.type = 'text/javascript'
        hubspotScript.id = 'hs-script-loader'
        hubspotScript.async = true
        hubspotScript.defer = true
        hubspotScript.src = '//js-eu1.hs-scripts.com/139771552.js'
        document.body.appendChild(hubspotScript)
        scripts.push(hubspotScript)
      }

      return () => {
        // Cleanup only scripts that were added by this effect
        scripts.forEach((script) => {
          if (document.body.contains(script)) {
            document.body.removeChild(script)
          }
        })
      }
    }
  }, [])



  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <Outlet />
          <MasterInit />
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
